import { MAX_INLINE_TEXT_BYTES, MAX_UPLOAD_FILE_BYTES } from '@highlight/common/product'

export const acceptFileTypes =
  'text/*,image/png,image/jpeg,image/webp,image/gif,image/svg+xml,image/x-icon,' +
  'application/json,application/xml,application/pdf,' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.ms-excel,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation,' +
  '.txt,.rtf,.md,.markdown,.mdown,.mkdn,.mdwn,.mkd,.org,.rst,.tex,.log,.ini,.cfg,.conf,.yml,.yaml,.toml,.json,.xml,.csv,.tsv,' +
  '.js,.jsx,.ts,.tsx,.py,.rb,.rs,.swift,.java,.kt,.go,.php,.pl,.sh,.bash,.zsh,.fish,.sql,.html,.htm,.xhtml,.css,.scss,.sass,.less,.svg,.cjs,.mjs,.cts,.mts,.vue,.svelte,.astro,' +
  '.c,.cpp,.h,.hpp,.cs,.fs,.vb,.r,.jl,.lua,.m,.mm,.scala,.groovy,.dart,.asm,.s,.elm,.erl,.ex,.exs,.hs,.lhs,.lisp,.clj,.cljs,.cljc,.edn,.ml,.mli,.ps1,.psm1,.psd1,.proto,.graphql,.gql,' +
  '.bat,.cmd,.awk,.sed,.vim,.emacs,.el,' +
  '.dockerfile,.dockerignore,.gitignore,.gitattributes,.env,.env.local,.env.development,.env.test,.env.production,' +
  '.babelrc,.eslintrc,.prettierrc,.stylelintrc,.htaccess,.nginx,.apache2'

const acceptedPatterns = acceptFileTypes.split(',').map((pattern) => pattern.trim())

export const isFileAccepted = ({ type, name }: { type: string; name: string }) => {
  // Check MIME type against patterns
  for (const pattern of acceptedPatterns) {
    if (pattern.includes('/')) {
      // This is likely a MIME type or wildcard, e.g. "text/*" or "application/pdf"
      if (pattern.endsWith('/*')) {
        // wildcard match: "text/*" should match "text/plain"
        const baseType = pattern.slice(0, pattern.indexOf('/*'))
        if (type.startsWith(baseType)) {
          return true
        }
      } else {
        // exact MIME type match
        if (type === pattern) {
          return true
        }
      }
    } else if (pattern.startsWith('.')) {
      // This is a file extension, e.g. ".txt"
      if (name.toLowerCase().endsWith(pattern.toLowerCase())) {
        return true
      }
    }
  }

  // If no pattern matched
  return false
}

/** Uploaded as bytes, or as text pulled out of the document, rather than read as text and sent inline. */
const isUploadedAsDocument = (type: string) =>
  type.startsWith('image/') ||
  type === 'application/pdf' ||
  type.includes('spreadsheetml') ||
  type.includes('excel') ||
  type.includes('wordprocessingml') ||
  type.includes('presentationml')

/**
 * Whether a picked file goes up with the message, as the upload button always attached files, or is granted to the
 * chat read-only. A file too large to upload, or a text file too long to send inline, is granted instead.
 */
export const isFileUploadable = (file: { type: string; name: string; size: number }) => {
  if (!isFileAccepted(file) || file.size >= MAX_UPLOAD_FILE_BYTES) {
    return false
  }
  return isUploadedAsDocument(file.type) || file.size <= MAX_INLINE_TEXT_BYTES
}
